export const navObjectContact = {
    isContactPage: true,    
}
export const navObjectHome = {
    isContactPage: false,    
}